import { parseTemplate } from 'url-template';
import mapPagination from '~/Api/Pagination/mapPagination';
import Pagination from '~/Api/Pagination/Pagination';
import ApiClient from '~/ApiClient';

import mapProductHistoryEvent from './mapProductHistoryEvent';
import ProductHistoryEvent from './ProductHistoryEvent';

export interface Result {
	items: ProductHistoryEvent[];
	pagination: Pagination;
}

export default function findProductHistory(
	client: ApiClient,
	productId: string,
	page: number,
	perPage: number
): Promise<Result> {
	const url = parseTemplate('products/{productId}/history{?page,perPage}');
	const parameters = { productId, page, perPage };

	return client
		.fetch(url.expand(parameters))
		.then((response) => response.json())
		.then((response) => ({
			items: response.items.map(mapProductHistoryEvent),
			pagination: mapPagination(response.pagination),
		}));
}
